module.exports = __webpack_public_path__ + "static/media/pause-outline.351f25de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/Player/Engaged/pause-outline.svg
// module id = 7431
// module chunks = 0